import { PAY_TYPE } from '@/apis/checkout/constants/constants';
import { createBusinessLogger } from '@/utils/logger/businessLogger';

/**
 * 详细追踪类型（错误码等），用于区分各种支付与结算场景下的异常和事件
 */
export enum SGM_TRACK_TYPE {
  //结算首页接口
  CHECKOUT_INDEX_API_SERVICE_ERROR = 'CHECKOUT_INDEX_API_SERVICE_ERROR',
  CHECKOUT_INDEX_API_CLIENT_NO_ITEMS_TO_BACK = 'CHECKOUT_INDEX_API_CLIENT_NO_ITEMS_TO_BACK',
  CHECKOUT_INDEX_API_CLIENT_ADDRESS_ERROR = 'CHECKOUT_INDEX_API_CLIENT_ADDRESS_ERROR',
  CHECKOUT_INDEX_API_CLIENT_ADDRESS_ERROR_TO_BACK = 'CHECKOUT_INDEX_API_CLIENT_ADDRESS_ERROR_TO_BACK',
  CHECKOUT_INDEX_API_CLIENT_OTHER_ERROR = 'CHECKOUT_INDEX_API_CLIENT_OTHER_ERROR',
  CHECKOUT_INDEX_API_SERVICE_CHANGE = 'CHECKOUT_INDEX_API_SERVICE_CHANGE',

  // 结算首页接口-支付列表为空
  CHECKOUT_INDEX_API_CLIENT_NO_PAYMENTS = 'CHECKOUT_INDEX_API_CLIENT_NO_PAYMENTS',

  // 提单接口
  CHECKOUT_SUBMIT_ORDER_NO_ITEMS_TO_BACK = 'CHECKOUT_SUBMIT_ORDER_NO_ITEMS_TO_BACK',
  CHECKOUT_SUBMIT_ORDER_OUT_STOCK = 'CHECKOUT_SUBMIT_ORDER_OUT_STOCK',
  CHECKOUT_SUBMIT_ORDER_ALL_OUT_STOCK_TO_BACK = 'CHECKOUT_SUBMIT_ORDER_ALL_OUT_STOCK_TO_BACK',
  CHECKOUT_SUBMIT_ORDER_ACTIVITY_LIMIT = 'CHECKOUT_SUBMIT_ORDER_ACTIVITY_LIMIT',
  CHECKOUT_SUBMIT_ORDER_VOUCHER_ERROR = 'CHECKOUT_SUBMIT_ORDER_VOUCHER_ERROR',
  CHECKOUT_SUBMIT_ORDER_PAY_ERROR_TO_NEXT_PAGE = 'CHECKOUT_SUBMIT_ORDER_PAY_ERROR_TO_NEXT_PAGE',
  CHECKOUT_SUBMIT_ORDER_PAY_RISK_MANAGEMENT_ERROR = 'CHECKOUT_SUBMIT_ORDER_PAY_RISK_MANAGEMENT_ERROR',
  CHECKOUT_SUBMIT_ORDER_PROMISE_CHANGE = 'CHECKOUT_SUBMIT_ORDER_PROMISE_CHANGE',
  CHECKOUT_SUBMIT_ORDER_OTHER_ERROR = 'CHECKOUT_SUBMIT_ORDER_OTHER_ERROR',
  CHECKOUT_SUBMIT_ORDER_NO_RESULT_CODE = 'CHECKOUT_SUBMIT_ORDER_NO_RESULT_CODE',
  CHECKOUT_SUBMIT_ORDER_SERVICE_CHANGE_CODE = 'CHECKOUT_SUBMIT_ORDER_SERVICE_CHANGE_CODE',
  CHECKOUT_SUBMIT_ORDER_BOOKING_NOT_START = 'CHECKOUT_SUBMIT_ORDER_BOOKING_NOT_START',

  // 轮询接口
  CHECKOUT_SUBMIT_ORDER_REDIRECT_FAILED = 'CHECKOUT_SUBMIT_ORDER_REDIRECT_FAILED',
  CHECKOUT_SUBMIT_ORDER_REDIRECT_FINISH = 'CHECKOUT_SUBMIT_ORDER_REDIRECT_FINISH',

  // Paypal
  PAYPAL_NO_QUICK_PAYMENT_SUCCESS_FLAG = 'PAYPAL_NO_QUICK_PAYMENT_SUCCESS_FLAG',
  PAYPAL_NO_CHECKOUT_ID = 'PAYPAL_NO_CHECKOUT_ID',
  PAYPAL_SDK_ERROR = 'PAYPAL_SDK_ERROR',

  // Wechat
  WECHAT_NO_COUNTDOWN_TIME = 'WECHAT_NO_COUNTDOWN_TIME',
  WECHAT_PAY_RESULT_ERROR = 'WECHAT_PAY_RESULT_ERROR',
  WECHAT_OTHER_ERROR = 'WECHAT_OTHER_ERROR',

  // Klarna
  KLARNA_SDK_LOAD_FAILED = 'KLARNA_SDK_LOAD_FAILED',
  KLARNA_DATA_ERROR = 'KLARNA_DATA_ERROR',
  KLARNA_HANDLE_PAYLOAD_ERROR = 'KLARNA_HANDLE_PAYLOAD_ERROR',
  KLARNA_INIT_ERROR = 'KLARNA_INIT_ERROR',
  KLARNA_LOAD_RESPONSE_ERROR = 'KLARNA_LOAD_RESPONSE_ERROR',
  KLARNA_PAYMENT_ERROR = 'KLARNA_PAYMENT_ERROR',

  // Google Pay
  GOOGLE_PAY_SDK_LOAD_FAILED = 'GOOGLE_PAY_SDK_LOAD_FAILED',
  GOOGLE_PAY_CLIENT_INIT_ERROR = 'GOOGLE_PAY_CLIENT_INIT_ERROR',
  GOOGLE_PAY_IS_READY_TO_PAY_ERROR = 'GOOGLE_PAY_IS_READY_TO_PAY_ERROR',
  GOOGLE_PAY_DATA_ERROR = 'GOOGLE_PAY_DATA_ERROR',
  GOOGLE_PAY_HANDLE_PAYMENT_ERROR = 'GOOGLE_PAY_HANDLE_PAYMENT_ERROR',
  GOOGLE_PAY_SDK_ERROR = 'GOOGLE_PAY_SDK_ERROR',

  // CREDIT CARD
  CREDIT_CARD_HANDLE_PAYLOAD_ERROR = 'CREDIT_CARD_HANDLE_PAYLOAD_ERROR',
  CREDIT_CARD_MISSING_PARAMETERS_ERROR = 'CREDIT_CARD_MISSING_PARAMETERS_ERROR',
  COMMON_CREDIT_CARD_PAYMENT_ERROR = 'COMMON_CREDIT_CARD_PAYMENT_ERROR',
  COMMON_CREDIT_CARD_NO_HTTP_URL = 'COMMON_CREDIT_CARD_NO_HTTP_URL',

  //Apple pay
  APPLE_PAY_SDK_LOAD_FAILED = 'APPLE_PAY_SDK_LOAD_FAILED',
  APPLE_PAY_INIT_PAYMENT_SESSION_ERROR = 'APPLE_PAY_INIT_PAYMENT_SESSION_ERROR',
  APPLE_PAY_PRICE_MISMATCH_ERROR = 'APPLE_PAY_PRICE_MISMATCH_ERROR',
  APPLE_PAY_DATA_ERROR = 'APPLE_PAY_DATA_ERROR',
  APPLE_PAY_FETCH_MERCHANT_SESSION_ERROR = 'APPLE_PAY_FETCH_MERCHANT_SESSION_ERROR',
  APPLE_PAY_NO_MERCHANT_SESSION_ERROR = 'APPLE_PAY_NO_MERCHANT_SESSION_ERROR',
  APPLE_PAY_SDK_ERROR = 'APPLE_PAY_SDK_ERROR',

  // 二次支付获取支付列表失败
  REPAY_ORDER_CLIENT_NO_PAYMENTS = 'REPAY_ORDER_CLIENT_NO_PAYMENTS',

  // 二次支付接口轮询接口
  REPAY_ORDER_REDIRECT_FAILED = 'REPAY_ORDER_REDIRECT_FAILED',
  REPAY_ORDER_REDIRECT_FINISH = 'REPAY_ORDER_REDIRECT_FINISH',

  // 二次支付
  REPAY_ORDER_PAY_RISK_MANAGEMENT_ERROR = 'REPAY_ORDER_PAY_RISK_MANAGEMENT_ERROR',
  REPAY_ORDER_COMMON_ERROR = 'REPAY_ORDER_COMMON_ERROR',

  // 支付完成页
  PAYMENT_FINISH_API_REDIRECT_FAILED = 'PAYMENT_FINISH_API_REDIRECT_FAILED',
  PAYMENT_FINISH_API_REDIRECT_FINISH = 'PAYMENT_FINISH_API_REDIRECT_FINISH',
}

export const SGM_TRACK_TYPE_MESSAGE = {
  //结算首页接口
  CHECKOUT_INDEX_API_CLIENT_NO_ITEMS_TO_BACK: '结算首页接口-无商品分堆信息返回上一页',
  CHECKOUT_INDEX_API_CLIENT_ADDRESS_ERROR: '结算首页接口-地址错误',
  CHECKOUT_INDEX_API_CLIENT_ADDRESS_ERROR_TO_BACK: '结算首页接口-地址错误返回上一页',
  CHECKOUT_INDEX_API_CLIENT_OTHER_ERROR: '结算首页接口-其他错误',
  CHECKOUT_INDEX_API_SERVICE_CHANGE: '结算首页接口-服务品变更',

  // 结算首页接口-支付列表为空
  CHECKOUT_INDEX_API_CLIENT_NO_PAYMENTS: '结算首页接口-支付列表为空',

  // 提单接口
  CHECKOUT_SUBMIT_ORDER_NO_ITEMS_TO_BACK: '提单接口-购物车无商品，返回上一页',
  CHECKOUT_SUBMIT_ORDER_OUT_STOCK: '提单接口-部分商品缺货',
  CHECKOUT_SUBMIT_ORDER_ALL_OUT_STOCK_TO_BACK: '提单接口-全部商品缺货，返回上一页',
  CHECKOUT_SUBMIT_ORDER_ACTIVITY_LIMIT: '提单接口-活动限购',
  CHECKOUT_SUBMIT_ORDER_VOUCHER_ERROR: '提单接口-优惠券校验失败',
  CHECKOUT_SUBMIT_ORDER_PAY_ERROR_TO_NEXT_PAGE: '提单接口-支付失败跳转订单列表/会员套餐选择',
  CHECKOUT_SUBMIT_ORDER_PAY_RISK_MANAGEMENT_ERROR: '提单接口-风控拦截',
  CHECKOUT_SUBMIT_ORDER_PROMISE_CHANGE: '提单接口-时效信息变更',
  CHECKOUT_SUBMIT_ORDER_OTHER_ERROR: '提单接口-其他错误',
  CHECKOUT_SUBMIT_ORDER_NO_RESULT_CODE: '提单接口-无返回码',
  CHECKOUT_SUBMIT_ORDER_SERVICE_CHANGE_CODE: '提单接口-服务品发生变化',

  // 结算页-轮询接口
  CHECKOUT_SUBMIT_ORDER_REDIRECT_FAILED: '轮询接口-支付失败',
  CHECKOUT_SUBMIT_ORDER_REDIRECT_FINISH: '轮询接口-轮询完成未获取到支付结果',

  // Paypal
  PAYPAL_NO_QUICK_PAYMENT_SUCCESS_FLAG: 'Paypal-无快捷支付成功标记',
  PAYPAL_NO_CHECKOUT_ID: 'Paypal-缺少checkoutId',
  PAYPAL_SDK_ERROR: 'Paypal-SDK错误',

  // Wechat
  WECHAT_NO_COUNTDOWN_TIME: '微信支付-缺少倒计时时间',
  WECHAT_PAY_RESULT_ERROR: '微信支付-结果异常',
  WECHAT_OTHER_ERROR: '微信支付-其他错误',

  // Klarna
  KLARNA_SDK_LOAD_FAILED: 'Klarna-SDK加载失败',
  KLARNA_INIT_ERROR: 'Klarna-初始化失败',
  KLARNA_DATA_ERROR: 'Klarna-支付数据异常',
  KLARNA_HANDLE_PAYLOAD_ERROR: 'Klarna-支付处理异常',
  KLARNA_PAYMENT_ERROR: 'Klarna-支付异常',

  // Google Pay
  GOOGLE_PAY_SDK_LOAD_FAILED: 'Google Pay-SDK加载失败',
  GOOGLE_PAY_CLIENT_INIT_ERROR: 'Google Pay-初始化失败',
  GOOGLE_PAY_IS_READY_TO_PAY_ERROR: 'Google Pay-是否可支付校验失败',
  GOOGLE_PAY_HANDLE_PAYMENT_ERROR: 'Google Pay-支付处理异常',
  GOOGLE_PAY_DATA_ERROR: 'Google Pay-支付数据异常',
  GOOGLE_PAY_SDK_ERROR: 'Google Pay-SDK异常',

  // CREDIT CARD
  CREDIT_CARD_HANDLE_PAYLOAD_ERROR: '信用卡-参数处理异常',
  CREDIT_CARD_MISSING_PARAMETERS_ERROR: '信用卡-缺少必要参数',
  COMMON_CREDIT_CARD_PAYMENT_ERROR: '信用卡-支付异常',
  COMMON_CREDIT_CARD_NO_HTTP_URL: '信用卡-无跳转httpUrl地址',

  //Apple pay
  APPLE_PAY_SDK_LOAD_FAILED: 'Apple Pay-SDK加载失败',
  APPLE_PAY_INIT_PAYMENT_SESSION_ERROR: 'Apple Pay-初始化支付会话失败',
  APPLE_PAY_DATA_ERROR: 'Apple Pay-支付数据异常',
  APPLE_PAY_PRICE_MISMATCH_ERROR: 'Apple Pay-支付价格不一致',
  APPLE_PAY_FETCH_MERCHANT_SESSION_ERROR: 'Apple Pay-获取商户认证信息接口失败',
  APPLE_PAY_NO_MERCHANT_SESSION_ERROR: 'Apple Pay-未获取到商户认证信息',
  APPLE_PAY_SDK_ERROR: 'Apple Pay-sdk异常',

  // 二次支付获取支付列表失败
  REPAY_ORDER_CLIENT_NO_PAYMENTS: '二次支付-获取支付列表失败',

  // 二次支付接口轮询接口
  REPAY_ORDER_REDIRECT_FAILED: '二次支付轮询接口-支付失败',
  REPAY_ORDER_REDIRECT_FINISH: '二次支付轮询接口-轮询完成未获取到支付结果',

  // 二次支付
  REPAY_ORDER_PAY_RISK_MANAGEMENT_ERROR: '二次支付-风控拦截',
  REPAY_ORDER_COMMON_ERROR: '二次支付-通用错误',

  // 支付完成页
  PAYMENT_FINISH_API_REDIRECT_FAILED: '支付完成页-支付失败',
  PAYMENT_FINISH_API_REDIRECT_FINISH: '支付完成页-轮询完成未获取到支付结果',
  // 页面点击

  CHECKOUT_PAGE_PAY_METHOD_CLICK: '切换支付方式',
  CHECKOUT_PAGE_COUPON_CLICK: '点击优惠券楼层',
  CHECKOUT_PAGE_SHIPPING_ADDRESS_CLICK: '点击修改配送地址楼层',
  CHECKOUT_PAGE_BILLING_ADDRESS_CLICK: '点击修改账单地址楼层',
  CHECKOUT_PAGE_PAY_BUTTON_CLICK: '点击支付按钮',
};

/**
 * 埋点主类型（区分API异常或JS异常等）
 */
export enum SGM_TRACK_MAIN_TYPE {
  CHECKOUT_API_ERROR = 'CHECKOUT_API_ERROR',
  CHECKOUT_JS_ERROR = 'CHECKOUT_JS_ERROR',
}

/**
 * 各支付方式的编号及名称映射
 */
export const SGM_PAY_METHOD = {
  [PAY_TYPE.APPLE]: 'APPLE',
  [PAY_TYPE.PAYPAL]: 'PAYPAL',
  [PAY_TYPE.CREDIT_CARD]: 'CREDIT_CARD',
  [PAY_TYPE.GOOGLE_PAY]: 'GOOGLE_PAY',
  [PAY_TYPE.WECHAT_PAY]: 'WECHAT_PAY',
  [PAY_TYPE.KLARNA]: 'KLARNA',
  [PAY_TYPE.IDEAL]: 'IDEAL',
  [PAY_TYPE.BANCONTACT]: 'BANCONTACT',
  [PAY_TYPE.JD_CREDIT_CARD]: 'JD_CREDIT_CARD',
};

/**
 * 支付的时机枚举，首次支付/二次支付
 */
export enum SGM_PAYMENT_TIME {
  FIRST = 'first',
  REPAY = 'repay',
}

export const CHECKOUT_EVENT_NAMES = {
  CHECKOUT_PAGE_ERROR: 'CHECKOUT_PAGE_ERROR',
  CHECKOUT_PAGE_PAY_METHOD_CLICK: 'CHECKOUT_PAGE_PAY_METHOD_CLICK',
  CHECKOUT_PAGE_COUPON_CLICK: 'CHECKOUT_PAGE_COUPON_CLICK',
  CHECKOUT_PAGE_SHIPPING_ADDRESS_CLICK: 'CHECKOUT_PAGE_SHIPPING_CLICK',
  CHECKOUT_PAGE_BILLING_ADDRESS_CLICK: 'CHECKOUT_PAGE_BILLING_ADD_CLICK',
  CHECKOUT_PAGE_PAY_BUTTON_CLICK: 'CHECKOUT_PAGE_PAY_BUTTON_CLICK',
};

// 导出类型定义，既可以当常量用也可以当类型用
export type CheckoutEventNames = typeof CHECKOUT_EVENT_NAMES;

// 暂时不需要分类，之后有需要再添加
const categoryNames: string[] = [
  'type',
  'payMethod',
  'detailCode',
  'isFirstPayment',
  'retryAttempts',
];
// 基础 Business Logger 实例 - 使用泛型约束事件名称
export const checkoutBusinessLogger = createBusinessLogger<CheckoutEventNames>(
  'pay_stat',
  categoryNames,
);
